<script setup lang="ts">
import type { AppRequestRoute } from '@shared/config'

import { AppText } from '@shared/ui/typography'
import { BtnPrimary } from '@shared/ui/buttons'

import { useHelperAction } from '../../api/helpers/action.hook'

defineOptions({
  name: 'HelperActionRow',
})

const props = withDefaults(defineProps<HelperActionRowProps>(), {
  buttonText: 'run',
})

interface HelperActionRowProps {
  label: string
  routeName: AppRequestRoute
  buttonText?: string
}

const { run, isRunning, canRun } = useHelperAction()

const handleClick = (): void => {
  void run(props.routeName)
}
</script>

<template>
  <div class="helper-action-row">
    <AppText
      name="body1"
      color="slate-900"
    >
      {{ label }}
    </AppText>
    <BtnPrimary
      :text="buttonText"
      :disabled="!canRun || isRunning"
      @click="handleClick"
    />
  </div>
</template>

<style scoped lang="scss" src="./HelperActionRow.scss" />
